<div class="w-100-p padding-10-lr padding-12-b scroll-y h-60">
  @if (alert()) {
    <div class="clr-row nxm clr-justify-content-center clr-align-items-baseline">
      <clr-alert class="clr-col-md-8 clr-col" clrAlertType="warning" [clrAlertClosable]="false">
        <clr-alert-item>
          <span class="alert-text">
            {{ 'Zuerst müssen ' + (alert() | titlecase) + ' eingetragen werden' | mrTranslate }}
          </span>
          <div class="alert-actions">
            <a (click)="view.emit(alert())" class="alert-action">
              {{ 'Gehen zu ' + (alert() | titlecase) | mrTranslate }}
            </a>
          </div>
        </clr-alert-item>
      </clr-alert>
    </div>
  }
  @if (objekteTable(); as table) {
    <div class="clr-row nxm height-half" style="height: 60%">
      <div class="clr-col-md-6 h-100 d-f col">
        <div class="d-f clr-justify-content-between clr-align-items-center">
          <h4 style="margin-top: 12px; margin-bottom: 4px">
            {{ 'Objekte' | mrTranslate }}
          </h4>
          <div class="btn-group btn-icon btn-sm">
            <button class="btn nym" (click)="isMultiMode.set(!isMultiMode())">
              @let shape = isMultiMode() ? 'times-circle' : 'layers';
              @let title = isMultiMode() ? 'abbrechen' : 'starten';
              <cds-icon
                [shape]="shape"
                solid="true"
                [title]="('Multi-Auswahl' | mrTranslate) + ' ' + (title | mrTranslate)" />
            </button>
            <button
              class="btn nym"
              (click)="filterStore.deleteAllFilters()"
              [disabled]="filterStore.filteredRows().length == table.rows.length">
              <cds-icon shape="filter-off" [title]="'Alle Filter zurücksetzen' | mrTranslate" />
            </button>
          </div>
        </div>
        <clr-datagrid
          [deselectButton]="!isMultiMode()"
          class="datagrid-compact fill-space"
          [clrDgItemsIdentityFn]="row => row?.OSTAMMID"
          [clrDgSelectionType]="isMultiMode() ? 'multi' : 'single'"
          [clrDgSelected]="selectedObjekte()"
          (clrDgSelectedChange)="selectedObjekte.set($event)"
          [clrDgCustomSelectAllEnabled]="true"
          (clrDgCustomSelectAll)="selectedObjekte.set($event ? filterStore.filteredRows() : [])"
          [clrDgRowSelection]="true">
          @for (column of table.columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id">
              <clr-dg-filter>
                <app-column-filter
                  [column]="column"
                  [objektTypIconValue]="filterStore.iconMap()"
                  [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                  (changes)="filterStore.onChange($event)" />
              </clr-dg-filter>
              <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                {{ column.id | titlecase | mrUnitText }}
              </ng-container>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="filterStore.filteredRows()"
            [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID">
            <clr-dg-row [clrDgItem]="row">
              @for (cell of table.columns; track cell.id) {
                <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>{{ filterStore.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      </div>
      <div class="clr-col-md-6 h-100">
        <h4 style="margin-block: 12px">{{ 'Verknüpfungen' | mrTranslate }}</h4>
        <div class="card item-table mt-0" style="height: calc(100% - 48px)">
          <div class="card-block scroll-y h-60 np">
            <form
              #heightRef
              clrForm
              (ngSubmit)="saveIfValid()"
              id="wartung-zuordung-form"
              [formGroup]="zuordnungFormGroup"
              class="width100 nxm clr-row clr-align-items-baseline"
              clrLabelSize="5">
              <clr-select-container class="nxm clr-col-xl-6">
                <label class="clr-required-mark">{{ 'Maske' | mrTranslate }}</label>
                <select clrSelect name="maske" formControlName="mID">
                  <option disabled [ngValue]="null"></option>
                  @for (maske of maskenListe(); track maske.ID) {
                    <option [ngValue]="+maske.ID">{{ maske.Name }}</option>
                  }
                </select>
                <clr-control-error *clrIfError="'required'">
                  {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                </clr-control-error>
              </clr-select-container>
              <clr-select-container class="nxm clr-col-xl-6">
                <label class="clr-required-mark">{{ 'Verantwortlich' | mrTranslate }}</label>
                <select clrSelect name="personal" class="cur-color" formControlName="pID">
                  <option disabled [ngValue]="null"></option>
                  @for (personal of personalListe(); track personal.ID) {
                    <option [ngValue]="+personal.ID">{{ personal.Bezeichnung }}</option>
                  }
                </select>
                <clr-control-error *clrIfError="'required'">
                  {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                </clr-control-error>
              </clr-select-container>

              <clr-number-input-container class="nxm padding-0-r clr-col-xl-6 clr-col-9">
                <label class="clr-required-mark clr-col-xl-5 clr-col-7">{{ 'Intervall' | mrTranslate }}</label>
                <input
                  clrNumberInput
                  type="number"
                  min="0"
                  class="clr-col-xl-7 clr-col-5"
                  name="intervall"
                  formControlName="intervall" />
                <clr-control-error *clrIfError="'required'">
                  {{ 'Erforderlich' | mrTranslate }}
                </clr-control-error>
                <clr-control-error *clrIfError="'min'">
                  {{ 'Mindestens 0' | mrTranslate }}
                </clr-control-error>
              </clr-number-input-container>
              <clr-select-container class="nxm padding-0-l clr-col-xl-2 clr-col-3">
                <label hidden></label>
                <select class="clr-col-12" clrSelect name="einheit" formControlName="einheit">
                  <option value="Tag">{{ 'Tag' | mrTranslate }}</option>
                  <option value="Monat">{{ 'Monat' | mrTranslate }}</option>
                </select>
              </clr-select-container>
              <clr-date-container class="nxm clr-col-xl-4">
                <label class="clr-required-mark">{{ 'Beginn' | mrTranslate }}</label>
                <input
                  #dateModel
                  clrDate
                  name="intervallbeginn"
                  autocomplete="off"
                  type="date"
                  [ngModel]="dateControl | localeDate"
                  (ngModelChange)="dateControl = localeDate.tosql($event)"
                  [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                  [disabled]="zuordnungFormGroup.disabled"
                  required />
                <clr-control-error *clrIfError="'required'">
                  {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                </clr-control-error>
              </clr-date-container>
            </form>
            <div style="min-height: 120px; padding: 0 5px 3px" [dymanicStyle]="heightRef" addPx="3">
              @if (zuordnungenTable(); as table) {
                <clr-datagrid
                  #zuordnungsGrid
                  class="datagrid-compact h-100"
                  [clrDgItemsIdentityFn]="row => row?.ID"
                  [clrDgSelectionType]="'single'"
                  [clrDgSelected]="[selectedZuordnung()]"
                  (clrDgSelectedChange)="selectedZuordnung.set($event[0])"
                  [clrDgRowSelection]="true">
                  @for (column of table.columns; track column.id) {
                    <clr-dg-column [clrDgField]="column.id">
                      <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['mid', 'pid'] }">
                        {{ column.id | titlecase | mrUnitText }}
                      </ng-container>
                    </clr-dg-column>
                  }
                  <clr-dg-row *clrDgItems="let row of table.rows" [clrDgItem]="row">
                    @for (cell of table.columns; track cell) {
                      <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                    }
                  </clr-dg-row>
                  <clr-dg-footer>{{ table.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                </clr-datagrid>
              }
            </div>
          </div>
          <div class="card-footer">
            <div class="btn-group btn-primary btn-icon margin-0-t clr-flex-shrink-0">
              <button
                type="submit"
                form="wartung-zuordung-form"
                class="btn btn-icon margin-12-l"
                [title]="'Speichern' | mrTranslate"
                [disabled]="!(insertItem() || selectedZuordnung())">
                <cds-icon shape="floppy" />
              </button>
              <button
                class="btn btn-icon btn-danger"
                [title]="'Löschen' | mrTranslate"
                (click)="deleteItem()"
                [disabled]="!selectedZuordnung()">
                <cds-icon shape="times" />
              </button>
              <button
                class="btn btn-icon btn-success"
                [title]="'Neu' | mrTranslate"
                (click)="addItem()"
                [disabled]="!selectedObjekte().length || insertItem()">
                <cds-icon shape="file" />
              </button>
            </div>
            <span class="name-cell">
              {{
                (insertItem() ? 'Neue Verknüpfung erstellen'
                : selectedZuordnung() ? 'Ausgewählte Verknüpfung bearbeiten'
                : ''
                ) | mrTranslate
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="clr-row nxm height-half" style="height: 40%">
      <div class="clr-col-md-6 h-100 padding-24-t">
        <div class="border-table h-100 scroll">
          <table class="table margin-0-t table-compact">
            <thead style="position: sticky; top: -1px; z-index: 3">
              <tr>
                <th>{{ 'Check' | mrTranslate }}</th>
                <th>{{ 'Detail' | mrTranslate }}</th>
                <th class="left">{{ 'Bezeichnung' | mrTranslate }}</th>
                <th class="left">{{ 'Username' | mrTranslate }}</th>
                <th class="left">{{ 'Status' | mrTranslate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (item of maskenListe(); track item.ID) {
                <tr>
                  <td>
                    <!-- TODO disabled + item.ID übernehmen -->
                    <button
                      class="btn btn-link w-h-auto"
                      [class.disabled]="zuordnungFormGroup.disabled"
                      (click)="useMaskeInForm(item.ID)"
                      [title]="'Das Wert in Form übernehmen' | mrTranslate">
                      <cds-icon shape="check" />
                    </button>
                  </td>
                  <td>
                    <button
                      class="btn btn-link w-h-auto"
                      (click)="showMaskeDetail(item.ID)"
                      [title]="'Arten in die Maske anzeigen' | mrTranslate">
                      <cds-icon shape="angle-double" direction="right" />
                    </button>
                  </td>
                  <td class="left">{{ item.Name }}</td>
                  <td class="left">{{ item.UserName }}</td>
                  <td class="left">{{ item.Status | tablePrettyPrint }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="clr-col-md-6 h-100 padding-24-t">
        <div class="border-table h-100 scroll">
          <table class="table margin-0-t table-compact">
            <thead style="position: sticky; top: -1px; z-index: 3">
              <tr>
                <th class="left">{{ 'Wartungsarten in Maske' | mrTranslate }}</th>
              </tr>
            </thead>
            <tbody>
              @if (maskenItems()) {
                @for (item of maskenItems(); track item.ID) {
                  <tr [class.headerRow]="item.Typ == 0">
                    <td class="left">{{ item.Bezeichnung }}</td>
                  </tr>
                } @empty {
                  <td class="left">{{ 'keine Daten vorhanden' | mrTranslate }}</td>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  }
</div>
